import { useEffect, useState } from "react";
import { X, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import InstallInstructionsDialog, {
  getPlatform,
  isStandalone,
  type Platform,
} from "./InstallInstructionsDialog";

const STORAGE_KEY = "install-banner-dismissed-at";
const DISMISS_DAYS = 1;

export default function InstallPromptBanner() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [platform, setPlatform] = useState<Platform>(null);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(STORAGE_KEY) ?? 0);
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_DAYS * 24 * 60 * 60 * 1000) return;
    if (isStandalone()) return;

    const detected = getPlatform();
    if (!detected) return;

    setPlatform(detected);
    setVisible(true);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div className="fixed inset-x-0 bottom-0 z-[110] md:hidden">
        <div className="mx-3 mb-3 rounded-xl border border-primary/20 bg-primary p-3 shadow-lg">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white/20">
              <Smartphone className="h-5 w-5 text-white" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-white">Dodaj aplikację na telefon</p>
              <p className="text-xs text-white/90">Szybki dostęp z ekranu głównego — bez paska adresu.</p>
            </div>
            <button
              type="button"
              onClick={handleDismiss}
              className="rounded-full p-1 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
              aria-label="Zamknij"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          <Button
            variant="secondary"
            size="sm"
            className="mt-3 w-full bg-white text-primary hover:bg-white/90"
            onClick={() => setOpen(true)}
          >
            Pokaż jak dodać
          </Button>
        </div>
      </div>

      <InstallInstructionsDialog open={open} onOpenChange={setOpen} platform={platform} />
    </>
  );
}
